import CryptoJS from 'crypto-js';
import axios from 'axios';
import { btoa, atob } from '../../lib/helpers';
import { postApi } from '../../lib/fetcher';

const feeManagement = {
  namespaced: true,

  state() {
    return {
      allData: [],
      totalData: 0,
      loading: false,
      cacheData: {},
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      item: null,
      insertProgress: 0,
      downloadFailedURL: '',
      countDone: 0,
      countSame: 0,
      exportId: null,
      ceountDataExport: 0,
      totalPage: 0,
      requestData: null,
    };
  },

  mutations: {
    setData(state, { payload }) {
      state.allData = payload.data.list;
    },

    setItem(state, { payload }) {
      state.item = payload.data.data;
    },

    setCategory(state, data) {
      state.allData = data;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearData(state) {
      state.allData = [];
      state.totalData = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalData(state, { payload }) {
      state.totalData = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setStateVariable(state, { payload, variable }) {
      state[variable] = payload;
    },

    setCancelation(state, payload) {
      state.requestData = payload;
    },
  },

  actions: {
    async getData(ctx, { date, page, itemsPerPage, sortBy, sortDesc, search }) {
      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearData');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      const sort_by = `${sortBy[0] ? sortBy[0] : 'id'} ${sort}`;

      if (search.last_update_date) {
        const [date1, date2] = search.last_update_date;

        const d1 = Date.parse(date1);
        const d2 = Date.parse(date2);

        if (d1 > d2) {
          const temp = date2;
          // eslint-disable-next-line no-param-reassign
          search.last_update_date[1] = date1;
          // eslint-disable-next-line no-param-reassign
          search.last_update_date[0] = temp;
        }
      }

      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sort_by,
        version: btoa(
          CryptoJS.SHA256(
            page.toString() +
              itemsPerPage.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/report/report-fee-management/index`;

      const addConfig = { cancelToken: axiosSource.token };
      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == '200') {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setData', { payload: responseData });
      }
      ctx.commit('setLoading', false);
    },

    async downloadFile(ctx, { id, date }) {
      ctx.commit('setLoading', true);

      const data = JSON.stringify({
        id,
        version: btoa(
          CryptoJS.SHA256(
            id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/report/report-fee-management/download`;

      const responseData = await postApi(ctx, urlApi, data);

      let returnVal = null;

      if (responseData?.code == '200') {
        returnVal = responseData.data.url_link;
      }

      ctx.commit('setLoading', false);
      return returnVal;
    },
  },
};
export default feeManagement;
